export const createEnumFromArray = <T, K extends keyof T, R extends boolean = false>(
  array: T[],
  key: T[K] extends string | number ? K : never,
  resultIndex?: R
): Record<T[K] & (string | number), R extends true ? number : T> => {
  type TResult = R extends true ? number : T
  return array.reduce(
    (acc, curr, index) => {
      const keyValue = curr[key]

      if (typeof keyValue !== 'string' && typeof keyValue !== 'number') {
        throw new TypeError(`Key value must be a string, number. Got: ${String(keyValue)}`)
      }

      if (acc[keyValue]) throw new Error(`Duplicate key: ${String(keyValue)}`)

      acc[keyValue] = (resultIndex ? index : curr) as TResult
      return acc
    },
    {} as Record<T[K] & (string | number), TResult>
  )
}

export const normalizeHex = (color?: string): string | undefined => {
  if (!color) return undefined
  return color.startsWith('#') ? color : `#${color}`
}

export function getInstagramUsername(url?: string): string | null {
  try {
    if (!url) return null
    url = url.trim()
    if (!/^https?:\/\//i.test(url)) {
      url = 'https://' + url
    }

    const parsed = new URL(url)
    const parts = parsed.pathname.split('/').filter(Boolean)
    return parts.length > 0 ? parts[0] : null
  } catch {
    return null
  }
}

export const normalizePhone = (phone?: string): string => {
  if (!phone) return ''
  return phone.replace(/\D/g, '')
}

/** Ссылка на клиентское QR-меню конкретного стола (домен зависит от окружения, см. VITE_CLIENT_MENU_URL) */
export const getClientMenuTableUrl = (brandUid: string, tableNumber: string): string => {
  const domain = import.meta.env.VITE_CLIENT_MENU_URL.replace(/\/+$/, '')
  return `${domain}/m/${encodeURIComponent(brandUid)}?t=${encodeURIComponent(tableNumber)}`
}

export const downloadQR = async (url: string, filename: string) => {
  try {
    const response = await fetch(url)
    const blob = await response.blob()
    const blobUrl = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = blobUrl
    link.download = filename.replace('.png', '.svg')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    window.URL.revokeObjectURL(blobUrl)
  } catch (error) {
    console.error(error)
  }
}
